import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AgentConfigContext = createContext(undefined);
export const AgentConfigProvider = ({ config, children }) => {
    const getBaseUrlFromAgentUrl = (agentUrl) => {
        try {
            const url = new URL(agentUrl);
            return url.origin;
        }
        catch (error) {
            console.warn('Failed to parse agent URL for base URL extraction:', agentUrl, error);
            return '';
        }
    };
    const getAgentBaseUrlFromAgentUrl = (agentUrl) => {
        try {
            const url = new URL(agentUrl);
            // Get the pathname and remove the last segment (e.g., '/stream', '/chat', '/api')
            const pathSegments = url.pathname.split('/').filter(segment => segment.length > 0);
            if (pathSegments.length >= 2) {
                // Remove the last segment (like 'stream', 'chat', 'api') and reconstruct the path
                const agentPath = '/' + pathSegments.slice(0, -1).join('/');
                return `${url.origin}${agentPath}`;
            }
            else {
                // If there's only one segment or no segments, just return the origin
                return url.origin;
            }
        }
        catch (error) {
            console.warn('Failed to parse agent URL for agent base URL extraction:', agentUrl, error);
            return '';
        }
    };
    const value = {
        config,
        getBaseUrlFromAgentUrl,
        getAgentBaseUrlFromAgentUrl,
    };
    return _jsx(AgentConfigContext.Provider, { value: value, children: children });
};
export const useAgentConfig = () => {
    const context = useContext(AgentConfigContext);
    if (!context) {
        throw new Error('useAgentConfig must be used within an AgentConfigProvider');
    }
    return context;
};
